export default function Orientation() {
  return (
    <section className="orient" id="orient">
      <div className="wrap">
        <div>
          <p className="eyebrow paper">Επαγγελματικος Προσανατολισμος</p>
          <h2>Ανακάλυψε τις σπουδές και το επάγγελμα που σου ταιριάζει</h2>
          <p>
            Με εξατομικευμένη συμβουλευτική και το τεστ επαγγελματικών
            ενδιαφερόντων Holland, αναγνωρίζεις καλύτερα τα ενδιαφέροντα, τις
            προτιμήσεις και τις επαγγελματικές κατευθύνσεις που σου ταιριάζουν.
          </p>
          <p>
            Παράλληλα, ενημερώνεσαι έγκυρα για σχολές, τμήματα, βάσεις εισαγωγής
            και μηχανογραφικό, ώστε να κάνεις τις επιλογές σου με μεγαλύτερη
            σιγουριά.
          </p>
        </div>
        <div className="actions">
          <a className="btn btn-ink" href="#contact">
            Κλείστε συνάντηση
          </a>
          <a className="btn btn-ghost" href="tel:+302251054070">
            Καλέστε μας
          </a>
        </div>
      </div>
    </section>
  );
}
